import { render, staticRenderFns } from "./kv-action-switch.vue?vue&type=template&id=51934a21&scoped=true"
import script from "./kv-action-switch.vue?vue&type=script&lang=js"
export * from "./kv-action-switch.vue?vue&type=script&lang=js"
import style0 from "./kv-action-switch.vue?vue&type=style&index=0&id=51934a21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51934a21",
  null
  
)

export default component.exports